import styled, { css } from "styled-components";

const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

const flexRow = css`
  display: flex;
  justify-content: space-between;
`;

export const SeparatorLine = styled.div`
  margin-left: ${({ theme }) => theme.space["space-4"]};
  border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
`;

export const Container = styled.div<{
  hasBorderTop?: boolean;
  isRow?: boolean;
  hasPaddingLeft?: boolean;
}>`
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  ${({ isRow }) => (isRow ? flexRow : flexColumn)}
  ${({ hasBorderTop }) =>
    hasBorderTop &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colorTokens.border.default};
    `}
    ${({ hasPaddingLeft }) =>
    hasPaddingLeft &&
    css`
      padding-left: 12px;
    `}
`;

export const MobileBetButtonsContainer = styled.div<{ hasOrder: boolean }>`
  ${flexColumn};
  padding: ${({ theme }) =>
    `0 ${theme.space["space-4"]} ${theme.space["space-4"]} ${theme.space["space-4"]}`};
  order: ${({ hasOrder }) => (hasOrder ? 2 : "initial")};

  & > div > div:first-child {
    flex-grow: 1;
  }

  & > div > div:last-child:not(:only-child) {
    margin-left: 4px;
  }

  button {
    height: 32px;
  }
`;
